module.exports = __webpack_public_path__ + "img/chipin_back.62d92d70.png";